import FmdGoodIcon from '@mui/icons-material/FmdGood'
import { TextField } from '@mui/material'
import classNames from 'classnames'
import { TService } from 'feature/serviceCenters/types'
import { useEffect, useState } from 'react'
import { useActions, useThunkDispatch } from 'store/hooks'
import { MenuBlock } from 'ui'

import style from './ServicesListWithSearch.module.scss'

type ServicesListWithSearchProps = {
  searchText: string
  filteredServices: TService[] | undefined | null
}
// поиск сц в списке
export function ServicesListWithSearch({
  searchText,
  filteredServices,
}: ServicesListWithSearchProps) {
  const [hasVerticalScroll, setHasVerticalScroll] = useState(false)
  const [container, setContainer] = useState<HTMLDivElement | null>(null)
  const { setServiceListSearchText } = useActions()
  const thunkDispatch = useThunkDispatch()

  useEffect(() => {
    if (container) {
      if (container.scrollHeight > container.clientHeight) {
        setHasVerticalScroll(true)
        return
      }
      setHasVerticalScroll(false)
    }
  }, [filteredServices, container])

  const handleSearchChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    thunkDispatch(setServiceListSearchText(event.target.value))
  }

  return (
    <div className='mt24'>
      <TextField
        className={style.searchInput}
        label='Поиск'
        InputProps={{
          type: 'search',
          autoComplete: 'off',
        }}
        value={searchText}
        onChange={handleSearchChange}
        data-testid='sc-search-input'
      />
      <div
        className={classNames(style.servicesList, {
          [style.listWithoutScroll]: !hasVerticalScroll,
        })}
        ref={ref => setContainer(ref)}
      >
        {!filteredServices ? (
          <></>
        ) : (
          filteredServices.map(service => {
            if (!service.address) return <></>
            return (
              <MenuBlock
                key={service.uuid + service.address}
                className={style.servicesListItem}
                Icon={FmdGoodIcon}
                link={`/servicecenters/${service.uuid}`}
                text={service.address}
                data-testid={`sc-service-item-${service.uuid}`}
              />
            )
          })
        )}
      </div>
    </div>
  )
}
